import React from 'react';
import { Img } from 'react-image';
import JapTestimonial from '../jap/JapTestimonial';
import Timer from '../jap/Timer';

interface Props {
	bgColor?: string;
	isDrawer?: boolean;
	expiry?: Date;
	isAIRoundSelected?: boolean;
}

const japTestimonialdata = [
	{
		name: 'Akshat Soni',
		imgUrl: '/assets/akshatSoni.png',
		companyName: 'F22 Labs Global',
		linkedinUrl: 'https://www.linkedin.com/in/akshatsoni8055/',
		description:
			'LevelUp who provides me with the right framework and support. Due to my training at LevelUp I was able to crack the interview at F22 Labs and get the job as Frontend Developer.',
	},
	{
		name: 'Pratik Sutariya',
		imgUrl: '/assets/shalabGupta.jpeg',
		companyName: 'WNS Global',
		linkedinUrl: 'https://www.linkedin.com/in/shalabh-dev/',
		description:
			'I joined LevelUp when I was trying to get a hold on my career. It was an important decision in my life and the best one I have made.',
	},
];

export const DesktopScreenCompanyBanner = ({ bgColor, isDrawer = false, expiry, isAIRoundSelected }: Props) => {
	const pointers = [
		{
			img: '/assets/users.svg',
			content: isAIRoundSelected ? (
				<span>Competitive Edge with AI Interviews</span>
			) : (
				<span>Get Interviewed by top Industry Experts.</span>
			),
		},
		{
			img: '/assets/chartBarIcon.svg',
			content: <span>Elevate your Level and skills</span>,
		},
		{
			img: '/assets/buildings.svg',
			content: <span>Unlock job opportunities</span>,
		},
	];

	return (
		<div
			className={`rounded-[8px] px-3 md:py-6 pt-2 ${
				isDrawer ? '' : 'dark:bg-[#1F2A37] border border-solid dark:border-[#c7c9d91a]'
			} !bg-[#F2F2F5] border border-[#EBEBF0]`}
		>
			<div className="flex items-center justify-center w-[100px] mx-auto h-[118px] md:hidden">
				<Img src={'/assets/yellowLevelIconShiny.svg'} />
			</div>
			<div className="text-[20px] font-[700] leading-[24px] dark:text-white text-center text-[#6750A3]">
				Interview Test
			</div>

			<div className="flex flex-col gap-4 mt-9">
				{pointers.map((p, i) => (
					<div key={i} className="dark:text-[#E4E4EB] text-[16px] flex items-center gap-2">
						<div className="w-[28px] h-[28px] max-w-[28px] max-h-[28px]">
							<Img src={p.img} />
						</div>
						<div className="w-full text-sm font-normal text-[#555770]">{p.content}</div>
					</div>
				))}
			</div>

			<div className="path-element-shine-animation bg-[#fff] rounded-[6px] text-xs font-inter py-2 flex items-center justify-center mt-5 w-full mx-auto text-center text-[#555770]">
				19 job seekers secured their dream jobs in the last week.
			</div>

			<div className="mt-8 max-w-[350px]">
				<JapTestimonial data={japTestimonialdata} customCss={'sm:h-[202px]'} />
			</div>

			{isDrawer ? (
				<div className="flex mt-8  md:mt-12 flex-col gap-6 items-center justify-center">
					<div className="flex gap-3 items-center justify-center">
						<div className="text-sm font-medium dark:text-[#FAFAFC] font-inter">Offer valid till</div>
						<div>
							<Timer time={expiry || 0} />{' '}
						</div>
					</div>
				</div>
			) : isAIRoundSelected ? null : (
				<>
					{/* <div className="text-xs text-[#FAFAFC] mt-8">Your technical round interviewers are working at</div>
					<div className="text-[10px] text-[#C7C9D9] mt-2">
						<span>
							<img
								src="/assets/companyLogosFrame.svg"
								alt={'companyLogosFrame'}
								className="inline h-[24px] object-contain mr-2"
							/>
						</span>
						& other top tier companies
					</div> */}
				</>
			)}
		</div>
	);
};
